import { render, staticRenderFns } from "./applications-switch-bar.vue?vue&type=template&id=786442fa"
import script from "./applications-switch-bar.vue?vue&type=script&lang=js"
export * from "./applications-switch-bar.vue?vue&type=script&lang=js"
import style0 from "./applications-switch-bar.vue?vue&type=style&index=0&id=786442fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports